document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener("change", function(e) {
    if (!e.target.matches(".select-option")) return;

    const select = e.target;
    const selected = e.target.options[e.target.selectedIndex];
    const price = selected.dataset.price / 100;
    const cprice = selected.dataset.cprice / 100;
    const selectedId = select.value;
    const moneyFormat = window.format;
    const priceBox = select.closest(".product-card-wrapper");
    // Variant id + image first (21 Oct 2026). The price code below used to throw on cards rendered without a
    // compare-at element, which left the previous variant id in the form, so "Cart" added the wrong variant.
    if (priceBox) {
      var idInput = priceBox.querySelector('form [name="id"]') || priceBox.querySelector('[name="id"]');
      if (idInput) idInput.value = selectedId;

      // Variant image on the card: show the selected variant's own image as the card's main image; options
      // without one fall back to the product's original main image (data-img/data-srcset: card-product.liquid).
      var cardRoot = select.closest('.card-wrapper') || priceBox;
      var mainImg = cardRoot.querySelector('.card__media img');
      if (mainImg) {
        if (!mainImg.dataset.gmOrigSrc) {
          mainImg.dataset.gmOrigSrc = mainImg.getAttribute('src') || '';
          mainImg.dataset.gmOrigSrcset = mainImg.getAttribute('srcset') || '';
        }
        if (selected.dataset.img) {
          mainImg.setAttribute('srcset', selected.dataset.srcset || '');
          mainImg.setAttribute('src', selected.dataset.img);
        } else {
          mainImg.setAttribute('srcset', mainImg.dataset.gmOrigSrcset);
          mainImg.setAttribute('src', mainImg.dataset.gmOrigSrc);
        }
      }
    }


      if (priceBox) {
        if (priceBox.querySelector(".reg_price")) priceBox.querySelector(".reg_price").innerHTML = moneyFormat.replace('{{amount}}', price);
        if(cprice > price){
          if (priceBox.querySelector(".compare_price")) priceBox.querySelector(".compare_price").innerHTML = moneyFormat.replace('{{amount}}', cprice);
        }else{
          if(priceBox.querySelector(".compare_price")){
            priceBox.querySelector(".compare_price").innerHTML = '';
          }
        }

        // Keep the "% off" pill in sync with the newly selected variant —
        // without this it kept showing whatever discount the page loaded
        // with, even after switching to a variant with a different (or no)
        // discount.
        var savePill = priceBox.querySelector(".card-save-pill");
        var percentOff = cprice > price ? Math.round(((cprice - price) / cprice) * 100) : 0;
        if (percentOff > 0) {
          if (!savePill) {
            var priceInner = priceBox.querySelector(".price__container-inner");
            if (priceInner) {
              savePill = document.createElement('span');
              savePill.className = 'card-save-pill';
              priceInner.appendChild(savePill);
            }
          }
          if (savePill) savePill.textContent = percentOff + '% off';
        } else if (savePill) {
          savePill.remove();
        }

        // Same idea for the per-pack price note — re-parse the pack count
        // from the newly selected variant's own title rather than leaving
        // the originally-rendered variant's numbers on screen.
        var packNote = priceBox.querySelector(".pack-price-note");
        if (packNote) {
          var titleText = (selected.textContent || '').toLowerCase().replace(/-/g, ' ');
          var packQty = 0;
          if (titleText.indexOf('pack') !== -1) {
            var words = titleText.trim().split(/\s+/);
            for (var i = 0; i < words.length; i++) {
              if (/^\d+(\.\d+)?$/.test(words[i])) {
                var n = parseFloat(words[i]);
                if (n > 0) {
                  packQty = n;
                  break;
                }
              }
            }
          }
          if (packQty > 0 && moneyFormat) {
            var perPack = price / packQty;
            var perPackDisplay = moneyFormat.replace('{{amount}}', perPack % 1 === 0 ? perPack : perPack.toFixed(2));
            packNote.innerHTML = perPackDisplay + ' / pack &middot; ' + packQty + ' pack' + (packQty !== 1 ? 's' : '');
            packNote.style.display = '';
          } else {
            packNote.style.display = 'none';
          }
        }
      }
  });
});